import utils from '../utils'
import {CrypticTypes} from '../enum'
import WxUserInfo from '../model/WxUserInfo'
import Vue from 'vue'

/**
 * 身份验证服务(区分H5、WX、APP)
 * @class AuthService
 */
export default class AuthService{
	
	/**
	 * @constructor
	 * @param {Object} config
	 */
	constructor(config) {
		this.config = config
		this.status = getAuthState(config)
		this.vueInstance = null
		
		this.getUrl = function(){
			const {wx: {appId = ''}} = this.config
			const redirectUrl = encodeURIComponent(location.href)
			return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
		}
	}
	
	/**
	 * 判断是否登录
	 * @method
	 */
	isLogin(){
		const {token} = getAuthState(this.config)
		return !!token
	}
	
	h5Auth({to: {path, query}, next} = {}){
		if(!this.isLogin()){
			utils.setLocalItem('LOGIN_DISPATCH', {path, query})
			if(next){
				next('/login')
			}else{
				throw new Error('H5 auth needs the parameter: next')
			}
		}
	}
	
	async wxAuth(routeCode){
		const code = utils.getLocalItem('session_code')
		if(!code){
			window.location.href = this.getUrl()
		}else{
			const userInfo = utils.getLocalItem('session_wx_user', true)
			if(!userInfo.openid){
				const userInfo = await this.vueInstance.$api.getWxUserInfo({
					appid: this.vueInstance.$config.wx.appId,
					code: routeCode
				})
				utils.setLocalItem('session_wx_user', new WxUserInfo(userInfo))
			}
		}
	}
	
	setVueInstance(vueInstance){
		vueInstance && (vueInstance instanceof Vue) && (this.vueInstance = vueInstance)
	}
}

function getAuthState(config){
	const {getLocalItem, base64toString} = utils, {token: {cacheKey = ''}, platform: {cryptic = CrypticTypes.BASE64}} = config || {}
	const token = base64toString(getLocalItem(cacheKey) || '')
	return {
		token
	}
}